import React, { useState, useEffect }                                                   from 'react';
import { Button, Badge, Alert }                                                         from 'react-bootstrap';
import { useDispatch, useSelector }                                                     from 'react-redux';
import clienteAxios                                                                     from '../../../../config/axios';
import Swal                                                                             from 'sweetalert2';
import moment                                                                           from 'moment';

import AuthoritiesService                                                               from '../../../../services/AuthoritiesService';
import NotificationForm                                                                 from './NotificationForm';

import { AGENDADA, CANCELADA }                                                          from '../../../../data/audienceStates';
import { ICON_CHECK, ICON_REDO, ICON_DELETE, ICON_CHECKOUT, ICON_NEW }                  from '../../../extras/icons';
import { listNotificationsAction, updateNotificationsAction, deleteNotificationsAction }from '../../../../actions/notificationsActions';
import { NOTIFICACIONES_CREAR, NOTIFICACIONES_ELIMINAR, NOTIFICACIONES_LISTAR }         from '../../../../data/objects';
import { NOTI_SISTEMA }                                                                 from '../../../../data/notificationTypes';
import { SuccessMessage, ErrorMessage, WaitingMessage, ConfirmDeleteMessage }           from '../../../extras/toastMessages';





const NotificationList = props => {



    // ------------------------------------------------------------------------------------------------------
    // DECLARACIONES ----------------------------------------------------------------------------------------
    // ------------------------------------------------------------------------------------------------------

    // Tomo los props
    const { audience, readOnly } = props;

    // Inicializo el dispatch
    const dispatch = useDispatch();

    // Inicializo el state local
    const [ show, setShow ] = useState(false);

    // Traigo el store
    const authorities = useSelector(state => state.auth.authorities);
    const notifications = useSelector(state => state.notifications.notifications);



    // ------------------------------------------------------------------------------------------------------
    // FUNCIONES --------------------------------------------------------------------------------------------
    // ------------------------------------------------------------------------------------------------------

    // Cargo las notificaciones al inicio
    useEffect(() => {
        // if(!notifications){
            dispatch(listNotificationsAction(audience));
        // }
    }, [audience]);
    
    // Manejo el cierre
    const handleClose = () => {
        setShow(false);
    }

    // Manejo la apertura
    const handleNew = e => {
        setShow(true);
    }

    // Manejo el reenvío de todas
    const handleResend = e => {
        Swal.fire({
            title: 'Reenviar Notificaciones?',
            text: 'Se reenviarán todas las notificaciones automáticas',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#e74a3b',
            confirmButtonText: 'Si, Reenviar'
        }).then((result) => {
            if(result.value){
                resendAll();
            }
        })
    }

    // Manejo el reenvío individual
    const handleResendOne = notification => {
        Swal.fire({
            title: 'Reenviar Notificación?',
            text: 'Se reenviarán la notificación actual',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#36b9cc',
            confirmButtonText: 'Si, Reenviar'
        }).then((result) => {
            if(result.value){
                //Reenvío la notificación
                resendNotification(notification);
            }
        })
    }

    // Manejo el realizado
    const handleFinalize = notification => {
        Swal.fire({
            title: 'Finalizar?',
            text: 'Se marcará como realizada la Notificación',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#1cc88a',
            confirmButtonText: 'Si, Finalizar'
        }).then((result) => {
            if(result.value){
                //Llamo al dispatch
                dispatch( updateNotificationsAction(notification) );
            }
        });
    }

    // Manejo el eliminar
    const handleDelete = notification => {
        Swal.fire({
            title: 'Eliminar Notificación?',
            text: 'La operación no se podrá revertir',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#e74a3b',
            confirmButtonText: 'Si, Eliminar'
        }).then((result) => {
            if(result.value){
                //Llamo al dispatch
                dispatch( deleteNotificationsAction(notification) );
            }
        })
    }

    // Reenvío el mail
    const resendNotification = async notification => {
        try
        {   //Cargo la espera
            WaitingMessage('Reenviando notificación');
            //Hago la consulta
            const response = await clienteAxios.post(`/notificacion/send/${notification.id}`);
            //Oculto la espera
            Swal.close();
            //Mensaje
            SuccessMessage('Notificación reenviada!!!');
        }
        catch(error)
        {   const response = error.response;
            let data = {
                data: null,
                message: 'Error al conectarse al servidor'
            };
            //Verifico si hay error
            if(response)
            {   data = response.data;
            }
            //Oculto la espera
            Swal.close();
            //Mensaje de error
            ErrorMessage(data.message);
        }
    }

    // Reenviar todas las automáticas
    const resendAll = async () => {
        try
        {   //Cargo la espera
            WaitingMessage('Reenviando notificaciones');
            //Hago la consulta
            const response = await clienteAxios.post(`/notificacion/send-by-audiencia/${audience.id}`);
            //Tomo la respuesta
            const dataResponse = response.data.map(d => (
                `${d.destinatario} ${d.emailSent === 'success' ? 'Ok':'Error'}`
            ))
            //Oculto la espera
            Swal.close();
            //Muestro los resultados
            Swal.fire({
                title: 'Resultado reenvío notificaciones',
                icon: 'info',
                html: dataResponse,
                showCloseButton: true,
                showCancelButton: false,
                focusConfirm: true,
                confirmButtonText: 'Aceptar',
                confirmButtonAriaLabel: 'Aceptar'
            })
        }
        catch(error)
        {   const response = error.response;
            let data = {
                data: null,
                message: 'Error al conectarse al servidor'
            };
            //Verifico si hay error
            if(response)
            {   data = response.data;
            }
            //Oculto la espera
            Swal.close();
            //Mensaje de error
            ErrorMessage(data.message);
        }
    }



    // ------------------------------------------------------------------------------------------------------
    // RENDERIZO --------------------------------------------------------------------------------------------
    // ------------------------------------------------------------------------------------------------------

    return (
        <div className="col-12">
            <div className="card shadow mb-4">
                <div className="card-header py-2 d-flex flex-row align-items-center justify-content-between">
                    <h6 className="m-0 font-weight-bold text-primary">NOTIFICACIONES REALIZADAS</h6>
                    {   audience.estado.id === AGENDADA || audience.estado.id === CANCELADA 
                            ?
                                authorities && AuthoritiesService.hasPermission(authorities, NOTIFICACIONES_CREAR) && !readOnly
                                    ?
                                        <div className="dropdown no-arrow">
                                            <Button variant="light" size="sm" className="float-right text-gray-400" onClick={handleResend}>
                                                    <ICON_REDO />
                                            </Button>
                                            <Button variant="light" size="sm" className="float-right text-gray-400 mr-2" onClick={handleNew}>
                                                    <ICON_NEW />
                                            </Button>                                            

                                            <NotificationForm
                                                show = { show }
                                                handleClose = { handleClose }
                                                audience = { audience }
                                            />
                                        </div>
                                    : 
                                        null
                            : 
                                null
                    }
                </div>
                {   notifications && authorities && AuthoritiesService.hasPermission(authorities, NOTIFICACIONES_LISTAR) 
                        ?
                            notifications.length > 0 
                                ?
                                    <table className="table table-hover table-sm">
                                        <thead>
                                            <tr className="table-light">
                                                {   !readOnly
                                                        ?
                                                            <th className="text-center">Fecha</th>
                                                        :
                                                            null
                                                }
                                                <th className="text-center">Tipo</th>
                                                <th className="text-center">Notificado</th>
                                                {   !readOnly
                                                        ?
                                                            <th className="text-center">Realizado</th>
                                                        :
                                                            null
                                                }
                                                <th className="text-center">Observación</th>
                                                {   !readOnly
                                                        ?
                                                            <th className="text-center">Usuario</th>
                                                        :
                                                            null
                                                }
                                                {   !readOnly && ( audience.estado.id===AGENDADA || audience.estado.id===CANCELADA )
                                                        ? 
                                                            <th className="text-center">Acción</th>
                                                        : 
                                                            null
                                                }
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {   notifications.map(notification => (
                                                    readOnly && !notification.realizado
                                                        ?
                                                            null
                                                        :
                                                            <tr key={`an${notification.id}`}>
                                                                {   !readOnly
                                                                        ?
                                                                            <td className="align-middle text-center">
                                                                                <small>{ moment(notification.fecha).format('DD/MM/YYYY HH:mm') }</small>
                                                                            </td>
                                                                        :
                                                                            null
                                                                }
                                                                <td className="align-middle text-center">
                                                                    <small>
                                                                        { notification.tipoDescripcion ? notification.tipoDescripcion : (notification.tipo ? notification.tipo.descripcion : '') }
                                                                    </small>
                                                                </td>
                                                                <td className="align-middle">
                                                                    { notification.destino }
                                                                </td>                                                        
                                                                {   !readOnly
                                                                        ?
                                                                            <td className="align-middle text-center">
                                                                                { notification.realizado 
                                                                                    ?
                                                                                        <Badge variant="success">SI</Badge>
                                                                                    :
                                                                                        <Badge variant="secondary">NO</Badge>
                                                                                }
                                                                            </td>
                                                                        :
                                                                            null
                                                                }
                                                                <td className="align-middle text-center">
                                                                    <small>{ notification.observacion }</small>
                                                                </td>
                                                                {   !readOnly
                                                                        ?                                                            
                                                                            <td className="align-middle">
                                                                                <small>{ notification.usuario ? `${notification.usuario.apellido}, ${notification.usuario.nombre}` : '' }</small>
                                                                            </td>
                                                                        :
                                                                            null
                                                                }
                                                                {   !readOnly && ( audience.estado.id===AGENDADA || audience.estado.id===CANCELADA )
                                                                        ?
                                                                            <td className="align-middle text-center">
                                                                                {   !notification.realizado 
                                                                                        ?
                                                                                            <React.Fragment>
                                                                                                {   authorities && AuthoritiesService.hasPermission(authorities, NOTIFICACIONES_CREAR) 
                                                                                                        ?
                                                                                                            <Button 
                                                                                                                variant = "success" 
                                                                                                                size = "sm"
                                                                                                                onClick = { ()=>handleFinalize(notification) }
                                                                                                            >
                                                                                                                <ICON_CHECK />
                                                                                                            </Button>
                                                                                                        : 
                                                                                                            null
                                                                                                }                                                                                        

                                                                                                {   authorities && AuthoritiesService.hasPermission(authorities, NOTIFICACIONES_ELIMINAR) 
                                                                                                        ?
                                                                                                            <Button 
                                                                                                                variant = "danger" 
                                                                                                                size = "sm" 
                                                                                                                className = "ml-2"
                                                                                                                onClick = { ()=>handleDelete(notification) }
                                                                                                            >
                                                                                                                <ICON_DELETE />
                                                                                                            </Button>
                                                                                                        : 
                                                                                                            null
                                                                                                }
                                                                                                
                                                                                            </React.Fragment>
                                                                                        : 
                                                                                            null
                                                                                }

                                                                                {   notification.tipoId === NOTI_SISTEMA 
                                                                                        ?
                                                                                            authorities && AuthoritiesService.hasPermission(authorities, NOTIFICACIONES_CREAR) 
                                                                                                ?
                                                                                                    <Button 
                                                                                                        variant = "info" 
                                                                                                        size = "sm" 
                                                                                                        className = "ml-2" 
                                                                                                        onClick = { ()=>handleResendOne(notification) }
                                                                                                    >
                                                                                                        <ICON_REDO />
                                                                                                    </Button>
                                                                                                : 
                                                                                                    null
                                                                                        : 
                                                                                            null
                                                                                }
                                                                            </td>
                                                                        :
                                                                            null
                                                                }
                                                            </tr>
                                                ))
                                            }
                                        </tbody>
                                    </table>
                                :
                                    <div className="card-body">
                                        <div className="row">
                                            <div className="col-12">
                                                <Alert variant="info">
                                                    No hay notificaciones cargadas
                                                </Alert>
                                            </div>
                                        </div>
                                    </div>
                    : 
                        null
                }
            </div>
        </div>
    );
};

export default NotificationList;
